import CheckboxGroup from './CheckboxGroup';
export default CheckboxGroup



// WEBPACK FOOTER //
// ./components/CheckboxGroup/index.js